import Bugsnag from "@bugsnag/js"
import bugsnagOnError from "./bugsnagOnError"

// Keep this module independent of React, application code, and analytics.
try {
	Bugsnag.start({
		apiKey: "f2f9e3ad85b1138c425a9d5643c6b9b8",
		releaseStage: process.env.NODE_ENV !== "production" ? "development" : "production",
		onError: bugsnagOnError,
	})
} catch {
	// Error reporting must never prevent the application from starting.
}

export function reportError(
	error: unknown,
	context: string,
	severity: "error" | "warning" = "error",
	metadata?: Record<string, unknown>,
) {
	try {
		Bugsnag.notify(error instanceof Error ? error : new Error(String(error)), (event) => {
			event.context = context
			event.severity = severity
			if (metadata) event.addMetadata("details", metadata)
		})
	} catch {
		// A blocked or unavailable reporter must not break recovery either.
	}
}
